var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chart-wind"}},[(_vm.activeChart)?_c('highcharts',{attrs:{"options":_vm.chartOptions,"callback":_vm.onLoad}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }